import api, { Paginated } from '.'
import { IBaseBodyComment, IBaseCommentRO } from './interfaces/IComment'
import { IPost } from './interfaces/IPost'
import { IPostComment } from './interfaces/IPostComment'

export const PostApi = (accessToken?: string) => ({
  create: async (body: IPost.IStore) => {
    const res = await api.post<IPost.IPostRO>('/posts', body, {
      headers: { Authorization: `Bearer ${accessToken}` },
    })

    return res.data
  },

  paginate: async (params: IPost.IPaginate) => {
    const res = await api.get<IPost.IPaginateRO>('/posts', {
      params,
      headers: { Authorization: `Bearer ${accessToken}` },
    })

    return res.data
  },

  get: async (id: number) => {
    const res = await api.get<IPost.IPostRO>(`/posts/${id}`, {
      headers: { Authorization: `Bearer ${accessToken}` },
    })

    return res.data
  },

  update: async (id: number, body: IPost.IStore) => {
    const res = await api.patch<IPost.IPostRO>(`/posts/${id}`, body)

    return res.data
  },

  delete: async (id: number) => {
    const res = await api.delete<boolean>(`/posts/${id}`)

    return res.data
  },

  like: async (id: number) => {
    const res = await api.post<boolean>(`/posts/${id}/like`, {
      headers: { Authorization: `Bearer ${accessToken}` },
    })

    return res.data
  },

  save: async (id: number) => {
    const res = await api.post<boolean>(`/posts/${id}/save`)

    return res.data
  },

  view: async (id: number) => {
    const res = await api.post<boolean>(`/posts/${id}/view`)

    return res.data
  },

  createComment: async (id: number, body: IBaseBodyComment) => {
    const res = await api.post<IPostComment.IPostCommentRO>(
      `/posts/${id}/comment`,
      body,
    )

    return res.data
  },

  updateComment: async (id: number, postId: number, body: IBaseBodyComment) => {
    const res = await api.patch<IPostComment.IPostCommentRO>(
      `/posts/${postId}/comment/${id}`,
      body,
    )

    return res.data
  },

  deleteComment: async (postId: number, id: number) => {
    const res = await api.delete<IPostComment.IPostCommentRO>(
      `/posts/${postId}/comment/${id}`,
    )

    return res.data
  },

  paginateComment: async (id: number, params: IPostComment.IPaginate) => {
    const res = await api.get<Paginated<IBaseCommentRO>>(
      `/posts/${id}/comment`,
      {
        params,
        headers: { Authorization: `Bearer ${accessToken}` },
      },
    )

    return res.data
  },

  likeComment: async (id: number) => {
    const res = await api.post<boolean>(`/posts/${id}/comment/like`)

    return res.data
  },

  vote: async (id: number, candidateId: number) => {
    const res = await api.post<boolean>(`/posts/${id}/vote`, { candidateId })

    return res.data
  },

  closeVote: async (id: number) => {
    const res = await api.post<boolean>(`/posts/${id}/vote/close`)

    return res.data
  },

  hashTag: async (username: string) => {
    const res = await api.get<{ text: string; count: number }[]>(
      `/posts/${username}/hash-tags`,
      {
        headers: { Authorization: `Bearer ${accessToken}` },
      },
    )

    return res.data
  },
})
